import React from "react";
import { useNavigate } from "react-router-dom";
import { useContent } from "../lib/content";

const AUTH_IMG = "/porchlight/auth-seller.jpg";

export function AuthShell({ children }) {
  const nav = useNavigate();
  const { content } = useContent();
  // Front door is always seller-branded (PorchLight or the agent's product
  // name). The buyer experience lives inside, after sign-in — not on the
  // public login/landing/sign-up pages.
  const brand = content?.branding?.product_name || "PorchLight";
  return (
    <div style={{ minHeight: "100vh", display: "grid", gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)", background: "var(--bg)" }} className="auth-shell">
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", padding: "clamp(32px, 6vw, 96px)" }}>
        <div style={{ width: "100%", maxWidth: 400 }}>
          <button onClick={() => nav("/")} className="font-serif" data-testid="auth-brand-link"
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer", fontSize: 24, fontWeight: 500, letterSpacing: "-0.01em", color: "var(--text)", marginBottom: 56, display: "block" }}>
            {brand}
          </button>
          {children}
        </div>
      </div>
      <div className="auth-image" style={{ background: "var(--surface-alt)", minHeight: "100vh" }}>
        <img src={AUTH_IMG} loading="eager" alt="A couple with the keys to their new home" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
      </div>
    </div>
  );
}

export function AuthField({ label, testid, type = "text", value, onChange, placeholder, autoFocus }) {
  return (
    <div>
      <div style={{ borderTop: "1px solid var(--text)", width: 28, marginBottom: 8 }} />
      <label className="overline" style={{ display: "block", marginBottom: 6 }}>{label}</label>
      <input
        data-testid={testid}
        className="auth-input"
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        required
      />
    </div>
  );
}
